namespace TabAurous.HR {
    export interface IncomeTaxSlabsForm {
        Code: Serenity.StringEditor;
        Narration: Serenity.StringEditor;
        EffectiveFrom: Serenity.DateEditor;
        CompanyId: Serenity.IntegerEditor;
        CurrencyId: Serenity.IntegerEditor;
        StdTaxExemption: Serenity.DecimalEditor;
        AllowTaxExemption: Serenity.BooleanEditor;
        IsDisabled: Serenity.BooleanEditor;
        TaxSlabDetails: IncomeTaxSlabDetailsEditor;
    }

    export class IncomeTaxSlabsForm extends Serenity.PrefixedContext {
        static formKey = 'HR.IncomeTaxSlabs';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IncomeTaxSlabsForm.init)  {
                IncomeTaxSlabsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.BooleanEditor;
                var w5 = IncomeTaxSlabDetailsEditor;

                Q.initFormType(IncomeTaxSlabsForm, [
                    'Code', w0,
                    'Narration', w0,
                    'EffectiveFrom', w1,
                    'CompanyId', w2,
                    'CurrencyId', w2,
                    'StdTaxExemption', w3,
                    'AllowTaxExemption', w4,
                    'IsDisabled', w4,
                    'TaxSlabDetails', w5
                ]);
            }
        }
    }
}
